import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { BsPersonWorkspace } from "react-icons/bs";

import { useDispatch, useSelector } from 'react-redux';
import { fetchSectorById } from '../../../store/sectorSlice';
import CommonModal from 'components/common/modal/DynamicModal';
import DynamicBreadcrumbs from 'components/breadcrumbs/dynamicbreadcrumbs';
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md"
import { MdOutlineDeleteOutline } from "react-icons/md";
import { addIndicator, removeIndicator, setWorkspaceLoaded, startNewWorkspace } from "store/workspaceSlice";
import { useAuth } from 'components/authentication/signup-login/AuthContext';
import SaveWorkspaceModal from 'components/authentication/signup-login/SaveWorkspaceModal';
import { useAutoLoadDefaultWorkspace } from 'components/authentication/signup-login/useAutoLoadDefaultWorkspace';

import '../../../assets/scss/cmn.scss'
import VerticalFilterBar from 'components/filter/verticalfilter';
import { fetchIndicatorById, fetchIndicators, clearIndicators, clearSectorIndicators } from '../../../store/filterSlice'
import { Button } from 'react-bootstrap';
import { FaRegUserCircle } from "react-icons/fa";
import IndicatorsList from "../Indicator/Indicator"
import { toast } from 'react-toastify';
import Cmn_Workspace from 'components/cmn_workspace/cmn_workspace';
import CustomToast from 'components/toast/customToast';
import AuthModalHandler from 'components/authentication/signup-login/AuthModalHandler';
import { MdInfoOutline } from "react-icons/md";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useBreakpoints } from 'hooks/useBreakpoints';


const SubSectorPage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const passedSector = location.state?.sector;
  const { selectedSector: sector, loading } = useSelector((state) => state.sector);
  const { breakpoints } = useBreakpoints();
      //=========== Mobile View =============
      const isMobile = breakpoints.down('md');



  const sectorData = useSelector((state) => state.sector.selectedSector);
  const [activeSubsectorId, setActiveSubsectorId] = useState(null);
  // const [selectedIndicators, setSelectedIndicators] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [indicatorData, setIndicatorData] = useState([]);
  const [indicatorFilterData, setFilterIndicatorData] = useState([]);
  const [filterMetaData, setMetaData] = useState([]);
  const [show, setShowModal] = useState(false);
  const [showWorkspace, setShowWorkspace] = useState(true);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [filterLoading, setFilterLoading] = useState(false);
  const { isAuthenticated, login } = useAuth();
  const [showSaveModal, setShowSaveModal] = useState(false);

  const selectedIndicators = useSelector(state => state.workspace.selectedIndicators);
  // all map features saved in workspace (same as MapConfig)
  const selectedMapFeatures = useSelector(state => state.workspace.selectedMapFeatures || []);

  // derive a simple localSelectedLocations list to pass into SaveWorkspaceModal
  const localSelectedLocations = Array.isArray(selectedMapFeatures) && selectedMapFeatures.length > 0
    ? selectedMapFeatures.map(f => ({
      value: f.properties?.code ?? f.id ?? null,
      label: f.name ?? f.properties?.name ?? '',
      geo_level: f.geo_level ?? f.properties?.geo_level_code ?? null,
    }))
    : [];
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [pendingSaveMode, setPendingSaveMode] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    key: '', // sorting field
    direction: 'asc',
  });
  const [filters, setFilters] = useState({
    geoLevel: [],
    selectedDatasets: [],
    selectedMinistries: [],
    customStartYear: 2011,
    customEndYear: 2021,
  });
  useEffect(() => {
    if (id) dispatch(fetchSectorById(id));
  }, [id, dispatch]);
  // ADD these after your existing useSelector calls
  const isWorkspaceLoaded = useSelector(state => state.workspace.isWorkspaceLoaded);
  const loadedWorkspaceName = useSelector(state => state.workspace.loadedWorkspaceName);
  const hasUnsavedChanges = useSelector(state => state.workspace.hasUnsavedChanges);
  const currentWorkspace = useSelector(state => state.workspace.currentWorkspace);
  useAutoLoadDefaultWorkspace();
  const getSector = sectorData?.sectors || passedSector;

  useEffect(() => {
    let called = false;
    dispatch(clearIndicators());
    dispatch(clearSectorIndicators());
    if (id && !called) {
      called = true;

      dispatch(fetchIndicatorById(id))
        .unwrap()
        .then((data) => {
          setIndicatorData(data.indicators);
          setMetaData(data.filter_metadata)
        })
        .catch((err) => {
        });
    }

    return () => {
      called = true;
    };
  }, [id, dispatch]);



  useEffect(() => {
    if (sector?.subsectors?.length && !activeSubsectorId) {
      const defaultSub = sector.subsectors.find(sub => sub.title?.toLowerCase().includes('population'));
      setActiveSubsectorId(defaultSub?.id || sector.subsectors[0]?.id);
    }
  }, [sector, activeSubsectorId]);

  const handleIndicatorSelect = (indicator) => {
toast(<CustomToast message={`${indicator.indicator_name} added to <b>workspace</b>`} type="success" />, { position: isMobile? "middle-center" : "top-right" });
    dispatch(addIndicator(indicator));
  };


  const subSectorList = (SubsectorList) => {
    navigate(`/sector/subsector/${SubsectorList.code}`, {
      state: { sector: passedSector, subsector: SubsectorList },
    });
  };
  const visualize = (selectedIndicators) => {
    navigate('/mapconfig', { state: { selectedIndicators } })
  }
  const onFilterApplyHandler = (filteredData) => {
    // mark that filters were applied (even if filteredData is empty)
    setIsFilterApplied(true);
    setFilterIndicatorData(Array.isArray(filteredData) ? filteredData : []);
  };

  const clearFilters = () => {
    setIsFilterApplied(false);
    setFilterIndicatorData([]);
  };
  const sortFilters = () => {

  }
  const applySorting = (key, direction) => {
    const sorted = [...filteredIndicators].sort((a, b) => {
      let aValue, bValue;

      switch (key) {
        case 'indicator_name':
          aValue = a.indicator_name?.toLowerCase() || '';
          bValue = b.indicator_name?.toLowerCase() || '';
          break;
        case 'agency_name':
          aValue = a.agency_name?.toLowerCase() || '';
          bValue = b.agency_name?.toLowerCase() || '';
          break;
        case 'year':
          aValue = parseInt(a.year) || 0;
          bValue = parseInt(b.year) || 0;
          break;
        case 'ministry':
          aValue = a.agency_code?.toLowerCase() || '';
          bValue = b.agency_code?.toLowerCase() || '';
          break;
        default:
          return 0;
      }

      if (aValue < bValue) return direction === 'asc' ? -1 : 1;
      if (aValue > bValue) return direction === 'asc' ? 1 : -1;
      return 0;
    });


  };
  const handleSortChange = (option) => {
    const newConfig = { ...sortConfig, key: option.value };
    setSortConfig(newConfig);
    applySorting(newConfig.key, newConfig.direction);
  };
  const [modalMode, setModalMode] = useState('save'); // Add this state at the top with other useState calls

  const handleSaveClick = (mode = 'save') => {
    if (!isAuthenticated) {
      setPendingSaveMode(mode);
      setShowAuthModal(true);
      return;
    }

    if (selectedIndicators.length === 0) {
      alert('Please select at least one indicator');
      return;
    }

    setModalMode(mode);
    setShowSaveModal(true);
  };
  const handleLoginSuccess = (response) => {

    const loginData = response.data || response;
    let userData = null;
    let token = null;

    if (loginData && loginData.user) {
      userData = loginData.user;
      token = loginData.token;
    } else {
      userData = {
        name: response.name || response.user?.name || 'User',
        email: response.email || response.user?.email || 'user@example.com'
      };
      token = response.token || response.access_token;
    }

    login(userData, token);
    setShowAuthModal(false);

    if (pendingSaveMode) {
        setTimeout(() => {
            // Double-check authentication before opening save modal
            const token = localStorage.getItem('authToken');
            const userData = localStorage.getItem('userData');
            
            if (token && userData) {
                setModalMode(pendingSaveMode);
                setShowSaveModal(true);
            } else {
                // If still not authenticated, show error
            }
            setPendingSaveMode(null);
        }, 1000); // Increased delay to ensure auth state is fully updated
    }
};
const handleSaveSuccess = (workspaceData) => {
  
  // Always load the saved workspace as current (for both new saves and save as)
  if (workspaceData.id && workspaceData.name) {
    console.log('Loading saved workspace:', workspaceData.name, 'ID:', workspaceData.id);
    // Add a small delay to ensure the workspace is properly created
    setTimeout(() => {
      // Dispatch action to load the workspace
      dispatch(setWorkspaceLoaded({
        id: workspaceData.id,
        name: workspaceData.name,
        workspace: workspaceData
      }));
      console.log('Workspace loaded with name:', workspaceData.name);
    }, 100);
  }
  
  setShowSaveModal(false);
};

const handleNewWorkspace = () => {
  // Clear all indicators and locations and reset to "My Workspace" state
  dispatch(startNewWorkspace());
};

  const toggleSortDirection = () => {
    const newConfig = {
      ...sortConfig,
      direction: sortConfig.direction === 'asc' ? 'desc' : 'asc',
    };
    setSortConfig(newConfig);
    applySorting(newConfig.key, newConfig.direction);
  };

  const baseData = isFilterApplied
    ? (Array.isArray(indicatorFilterData) ? indicatorFilterData : [])
    : (Array.isArray(indicatorData) ? indicatorData : []);

  const search = searchTerm?.trim().toLowerCase() || "";
  const filteredIndicators = search
    ? baseData.filter((ind) => (ind.indicator_name || "").toLowerCase().includes(search))
    : baseData;

  const filteredSupertags = sector?.supertags?.filter(sub => sub.name !== 'NA');

  if (loading) return <div className="p-4">Loading...</div>;
  if (!sector) return <div className="p-4">Sector not found</div>;
  return (
    <>
      <button className="btn  d-flex align-items-center ui-wp rotated-btn" style={{ backgroundColor: '#a3cefa' }} onClick={() => setShowWorkspace(!showWorkspace)}>
        <BsPersonWorkspace size={20} className="me-1 " />
        Workspace
      </button>

      <div className="container-fluid bg-white py-4">
        <div className="row">
          <div className={` ${!showWorkspace ? 'col-md-9' : 'col-md-12'}`}>
            <DynamicBreadcrumbs />
            <div className="mb-4 ui-sectors-cards">
              <h4 className="mb-2 text-warning">{passedSector?.name || sectorData.name}</h4>
              <p className='color-dark-blue'>{passedSector?.desc || sectorData.sectors.desc}</p>
              {filteredSupertags?.length > 0 && (
                <>
                  <h5 className="mt-1">Sub Sectors</h5>
                  <div className="d-flex flex-wrap gap-2 mb-2">
                    {filteredSupertags.map((sub) => (
                      <button
                        key={sub.code}
                        className={`btn ${activeSubsectorId === sub.code
                          ? 'btn-primary btn-sm'
                          : 'btn-outline-primary btn-sm'
                          }`}
                        onClick={() => {
                          subSectorList(sub);
                          setSearchTerm('');
                        }}
                      >
                        {sub.name}
                      </button>
                    ))}
                  </div>
                </>
              )}
            </div>
            <IndicatorsList
              indicatorData={indicatorData}
              filterMetaData={filterMetaData}
              onIndicatorSelect={handleIndicatorSelect}
              selectedIndicators={selectedIndicators}
              onFilterApply={onFilterApplyHandler}
            />

          </div>


          {!showWorkspace && (
            <div
              className="position-fixed end-0 bg-white workspace-scroll shadow"
              style={{
                top: '68px',
                width: '420px',
                height: '100vh',
                zIndex: 1050,
                overflowY: 'scroll',
                padding: '0',
                borderLeft: '1px solid #ddd',
                msOverflowStyle: 'none',
                scrollbarWidth: 'none',
              }}
            >
              <div className="h-100 border-0">
                <div className="card-header ui-card-header d-flex justify-content-between align-items-center border-0">
                  <h5 className="mb-0">
                    <FaRegUserCircle /> &nbsp;
                    {isWorkspaceLoaded ? loadedWorkspaceName : 'My Workspace'}
                    {hasUnsavedChanges && <span className="text-warning ms-2">*</span>}&nbsp;
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="filter-tooltip">
                          <p>Click save to access your work later.</p>
                        </Tooltip>
                      }
                    >
                      <span>
                        <MdInfoOutline style={{ cursor: "pointer", color: "#000000" }} />
                      </span>
                    </OverlayTrigger>
                  </h5>
                  <button
                    className="btn btn-sm btn-outline-dark"
                    onClick={() => setShowWorkspace(true)}
                  >
                    <MdOutlineKeyboardDoubleArrowRight />
                  </button>
                </div>
                <div className="card-body pt-3 p-2">
                  <div className='row'>
                    <div className='col-md-4'><h5 className='f-14 fw-bold'>Indicators</h5></div>
                    <div className='col-md-8'>
                      <div className='d-flex ui-up'>
                        <div className='p-1'>
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={() => handleSaveClick(isWorkspaceLoaded ? 'update' : 'save')}
                          >
                            <i className={`bi ${isWorkspaceLoaded ? 'bi-arrow-repeat' : 'bi-save'} me-1`}></i>
                            {isWorkspaceLoaded ? 'Update' : 'Save'}
                          </Button>
                        </div>
                        <div className="p-1">
                          <Button variant="outline-primary" className="btn-sm f-14" onClick={() => handleSaveClick('saveAs')}>
                            Save As
                          </Button>
                        </div>
                        <div className="p-1">
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={handleNewWorkspace}
                          >
                            <i className="bi bi-plus-circle me-1"></i> New
                          </Button>                        </div>

                      </div>
                    </div>
                  </div>
                  <Cmn_Workspace visualize={(inds) => {visualize(inds)} }
                showWorkspace={showWorkspace} 
        setShowWorkspace={setShowWorkspace}/>
                </div>

              </div>
            </div>
          )}


          <CommonModal
            isOpen={show}
            onClose={() => setShowModal(false)}
            title="Modal Title"
            footer={
              <>
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
                <button className="btn btn-primary">Save changes</button>
              </>
            }
          >
            <p>This is a dynamic modal body</p>
          </CommonModal>
        </div>
      </div>
      <SaveWorkspaceModal
        show={showSaveModal}
        handleClose={() => setShowSaveModal(false)}
        onSave={handleSaveSuccess}
        selectedIndicators={selectedIndicators}
        selectedLocations={localSelectedLocations}
        allMapFeatures={selectedMapFeatures}
        mode={modalMode}
      />
      <AuthModalHandler
        show={showAuthModal}
        handleClose={() => {
          setShowAuthModal(false);
          setPendingSaveMode(null);
        }}
        initialMode="login"
        onLoginSuccess={handleLoginSuccess}
      />

    </>

  );
};

export default SubSectorPage;
